import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { copyTextToClipBoard } from 'common/utils';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

const CopyIconButton = ({ text, tooltipText }) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = () => {
    if (text) {
      copyTextToClipBoard(text);
      enqueueSnackbar('Copied to clipboard', { variant: 'success', autoHideDuration: 2000 });
    }
  };

  if (!text) return null;

  return (
    <span className='CopyIconButton'>
      <Tooltip title={tooltipText || 'Copy to clipboard'} arrow>
        <IconButton size='small' onClick={handleCopy} sx={{ ml: 0.5 }}>
          <ContentCopyIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    </span>
  );
};

CopyIconButton.propTypes = {
  text: PropTypes.string,
  tooltipText: PropTypes.string,
};

CopyIconButton.defaultProps = {
  text: '',
  tooltipText: 'Copy to clipboard',
};

export default CopyIconButton;
